export const    USER = 'USER';
export const    USER_SUCCESS = 'USER_SUCCESS';
export const    USER_ERROR = 'USER_ERROR';

export const    ADD_USER = 'ADD_USER';
export const    ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const    ADD_USER_ERROR = 'ADD_USER_ERROR';

export const    UPDATE_USER = 'UPDATE_USER';
export const    UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const    UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';

export const    DELETE_USER = 'DELETE_USER';
export const    DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const    DELETE_USER_ERROR = 'DELETE_USER_ERROR';